// Generated by Melange

import * as Buhta_taxapis__Buhta_tax_control_v1_person_category from "./buhta_tax_control_v1_person_category.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  461,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "PensionerAge"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "PensionerDuty"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Disabled"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "DisabledPermanent"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Veteran"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "GuardianDisabled"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "GuardianOrphaned"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Adopter"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Children"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Maternity"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Convict"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "MotherMany"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Student"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "PersonCategoryBenefit"
                      ]]
                  },
                  "V1alpha1"
                ]]
            },
            "Control"
          ]]
      },
      "Tax"
    ]]
});

const Tax = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  885,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "PensionerAge"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "PensionerDuty"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Disabled"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DisabledPermanent"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Veteran"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "GuardianDisabled"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "GuardianOrphaned"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Adopter"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Children"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Maternity"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Convict"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "MotherMany"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Student"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "PersonCategoryBenefit"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Control"
    ]]
});

const Control = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  1307,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "PensionerAge"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "PensionerDuty"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Disabled"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DisabledPermanent"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Veteran"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "GuardianDisabled"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "GuardianOrphaned"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Adopter"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Children"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Maternity"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Convict"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "MotherMany"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Student"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PersonCategoryBenefit"
          ]]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  1727,
  12
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PensionerAge"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PensionerDuty"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Disabled"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DisabledPermanent"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Veteran"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "GuardianDisabled"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "GuardianOrphaned"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Adopter"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Children"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Maternity"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Convict"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "MotherMany"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Student"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PersonCategoryBenefit"
    ]]
});

const PersonCategoryBenefit = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2140,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PensionerAge"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PensionerDuty"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Disabled"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DisabledPermanent"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Veteran"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "GuardianDisabled"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "GuardianOrphaned"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Adopter"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Children"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Maternity"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Convict"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "MotherMany"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Student"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const PensionerAge = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2169,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const PensionerDuty = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2223,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Disabled = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2279,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DisabledPermanent = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2337,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Veteran = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2391,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GuardianDisabled = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2447,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GuardianOrphaned = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2507,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Adopter = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2568,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Children = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2631,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Maternity = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2691,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Convict = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2751,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const MotherMany = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2809,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Student = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.ml",
  2865,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.PensionerAge";
}

function make(param) {
  
}

function merge(param, param$1) {
  
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p(writer, param) {
  Curry._1(serialize, writer);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize, writer);
  return writer;
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.PensionerAge", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.PensionerAge", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, PensionerAge, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.PensionerDuty";
}

function make$1(param) {
  
}

function merge$1(param, param$1) {
  
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$1(writer, param) {
  Curry._1(serialize$1, writer);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$1, writer);
  return writer;
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.PensionerDuty", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.PensionerDuty", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, PensionerDuty, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Disabled";
}

function make$2(end_date, param) {
  return {
    end_date: end_date
  };
}

const $$let = Google_type__Google_type_date.Google.Type.$$Date;

const merge_end_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "end_date",
    "endDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    end_date: Curry._2(merge_end_date, t1.end_date, t2.end_date)
  };
}

function spec(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "end_date",
      "endDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.end_date);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor(end_date) {
  return {
    end_date: end_date
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Disabled", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.end_date);
  };
}

function constructor$1(end_date) {
  return {
    end_date: end_date
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Disabled", spec(undefined), constructor$1);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Disabled, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.DisabledPermanent";
}

function make$3(param) {
  
}

function merge$3(param, param$1) {
  
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$3(writer, param) {
  Curry._1(serialize$3, writer);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$3, writer);
  return writer;
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.DisabledPermanent", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.DisabledPermanent", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DisabledPermanent, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Veteran";
}

function make$4(param) {
  
}

function merge$4(param, param$1) {
  
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$4(writer, param) {
  Curry._1(serialize$4, writer);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$4, writer);
  return writer;
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Veteran", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Veteran", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Veteran, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.GuardianDisabled";
}

function make$5(children, param) {
  return {
    children: children
  };
}

const merge_children = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "children",
    "children"
  ],
  Ocaml_protoc_plugin__Spec.int32_int
]));

function merge$5(t1, t2) {
  return {
    children: Curry._2(merge_children, t1.children, t2.children)
  };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "children",
      "children"
    ],
    Ocaml_protoc_plugin__Spec.int32_int
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.children);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$2(children) {
  return {
    children: children
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.GuardianDisabled", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.children);
  };
}

function constructor$3(children) {
  return {
    children: children
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.GuardianDisabled", spec$1(undefined), constructor$3);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GuardianDisabled, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.GuardianOrphaned";
}

function make$6(children, param) {
  return {
    children: children
  };
}

const merge_children$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "children",
    "children"
  ],
  Ocaml_protoc_plugin__Spec.int32_int
]));

function merge$6(t1, t2) {
  return {
    children: Curry._2(merge_children$1, t1.children, t2.children)
  };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "children",
      "children"
    ],
    Ocaml_protoc_plugin__Spec.int32_int
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.children);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$4(children) {
  return {
    children: children
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.GuardianOrphaned", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.children);
  };
}

function constructor$5(children) {
  return {
    children: children
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.GuardianOrphaned", spec$2(undefined), constructor$5);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GuardianOrphaned, {
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

function name$7(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Adopter";
}

function make$7(end_date, children, param) {
  return {
    end_date: end_date,
    children: children
  };
}

const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_end_date$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "end_date",
    "endDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

const merge_children$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "children",
    "children"
  ],
  Ocaml_protoc_plugin__Spec.int32_int
]));

function merge$7(t1, t2) {
  return {
    end_date: Curry._2(merge_end_date$1, t1.end_date, t2.end_date),
    children: Curry._2(merge_children$2, t1.children, t2.children)
  };
}

function spec$3(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "end_date",
      "endDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "children",
      "children"
    ],
    Ocaml_protoc_plugin__Spec.int32_int
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.end_date, param.children);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$6(end_date, children) {
  return {
    end_date: end_date,
    children: children
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Adopter", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.end_date, param.children);
  };
}

function constructor$7(end_date, children) {
  return {
    end_date: end_date,
    children: children
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Adopter", spec$3(undefined), constructor$7);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Adopter, {
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

function name$8(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Children";
}

function make$8(end_date, param) {
  return {
    end_date: end_date
  };
}

const $$let$2 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_end_date$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "end_date",
    "endDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  })
]));

function merge$8(t1, t2) {
  return {
    end_date: Curry._2(merge_end_date$2, t1.end_date, t2.end_date)
  };
}

function spec$4(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "end_date",
      "endDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.end_date);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$8(end_date) {
  return {
    end_date: end_date
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Children", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.end_date);
  };
}

function constructor$9(end_date) {
  return {
    end_date: end_date
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Children", spec$4(undefined), constructor$9);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Children, {
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

function name$9(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Maternity";
}

function make$9(end_date, param) {
  return {
    end_date: end_date
  };
}

const $$let$3 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_end_date$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "end_date",
    "endDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge$9(t1, t2) {
  return {
    end_date: Curry._2(merge_end_date$3, t1.end_date, t2.end_date)
  };
}

function spec$5(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "end_date",
      "endDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$9(writer, param) {
  Curry._2(serialize$9, writer, param.end_date);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$10(end_date) {
  return {
    end_date: end_date
  };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$9, writer);
  });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Maternity", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.end_date);
  };
}

function constructor$11(end_date) {
  return {
    end_date: end_date
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Maternity", spec$5(undefined), constructor$11);
});

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$9, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Maternity, {
  make: make$9,
  to_proto: to_proto$9,
  from_proto: from_proto$9,
  to_json: to_json$9,
  from_json: from_json$9,
  name: name$9,
  merge: merge$9,
  to_proto$p: to_proto$p$9,
  from_proto_exn: from_proto_exn$9,
  from_json_exn: from_json_exn$9
});

function name$10(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Convict";
}

function make$10(end_date, param) {
  return {
    end_date: end_date
  };
}

const $$let$4 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_end_date$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "end_date",
    "endDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

function merge$10(t1, t2) {
  return {
    end_date: Curry._2(merge_end_date$4, t1.end_date, t2.end_date)
  };
}

function spec$6(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "end_date",
      "endDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$10(writer, param) {
  Curry._2(serialize$10, writer, param.end_date);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$10(writer, t);
  return writer;
}

function constructor$12(end_date) {
  return {
    end_date: end_date
  };
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$10, writer);
  });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Convict", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.end_date);
  };
}

function constructor$13(end_date) {
  return {
    end_date: end_date
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Convict", spec$6(undefined), constructor$13);
});

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$10, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Convict, {
  make: make$10,
  to_proto: to_proto$10,
  from_proto: from_proto$10,
  to_json: to_json$10,
  from_json: from_json$10,
  name: name$10,
  merge: merge$10,
  to_proto$p: to_proto$p$10,
  from_proto_exn: from_proto_exn$10,
  from_json_exn: from_json_exn$10
});

function name$11(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.MotherMany";
}

function make$11(param) {
  
}

function merge$11(param, param$1) {
  
}

const serialize$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$11(writer, param) {
  Curry._1(serialize$11, writer);
}

function to_proto$11(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$11, writer);
  return writer;
}

const from_proto_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$11(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$11, writer);
  });
}

function to_json$11(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.MotherMany", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.MotherMany", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$11(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$11, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, MotherMany, {
  make: make$11,
  to_proto: to_proto$11,
  from_proto: from_proto$11,
  to_json: to_json$11,
  from_json: from_json$11,
  name: name$11,
  merge: merge$11,
  to_proto$p: to_proto$p$11,
  from_proto_exn: from_proto_exn$11,
  from_json_exn: from_json_exn$11
});

function name$12(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Student";
}

function make$12(end_date, param) {
  return {
    end_date: end_date
  };
}

const $$let$5 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_end_date$5 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "end_date",
    "endDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$5.name,
    make: $$let$5.make,
    from_proto: $$let$5.from_proto,
    from_proto_exn: $$let$5.from_proto_exn,
    to_proto: $$let$5.to_proto,
    to_proto$p: $$let$5.to_proto$p,
    merge: $$let$5.merge,
    to_json: $$let$5.to_json,
    from_json_exn: $$let$5.from_json_exn,
    from_json: $$let$5.from_json
  })
]));

function merge$12(t1, t2) {
  return {
    end_date: Curry._2(merge_end_date$5, t1.end_date, t2.end_date)
  };
}

function spec$7(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "end_date",
      "endDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$12(writer, param) {
  Curry._2(serialize$12, writer, param.end_date);
}

function to_proto$12(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$12(writer, t);
  return writer;
}

function constructor$14(end_date) {
  return {
    end_date: end_date
  };
}

const from_proto_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$12(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$12, writer);
  });
}

function to_json$12(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Student", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.end_date);
  };
}

function constructor$15(end_date) {
  return {
    end_date: end_date
  };
}

const from_json_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit.Student", spec$7(undefined), constructor$15);
});

function from_json$12(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$12, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Student, {
  make: make$12,
  to_proto: to_proto$12,
  from_proto: from_proto$12,
  to_json: to_json$12,
  from_json: from_json$12,
  name: name$12,
  merge: merge$12,
  to_proto$p: to_proto$p$12,
  from_proto_exn: from_proto_exn$12,
  from_json_exn: from_json_exn$12
});

function name$13(param) {
  return ".buhta.tax.control.v1alpha1.PersonCategoryBenefit";
}

function make$13(categoryOpt, begin_date, benefitOpt, param) {
  const category = categoryOpt !== undefined ? categoryOpt : Curry._1(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory.from_int_exn, 0);
  const benefit = benefitOpt !== undefined ? benefitOpt : "not_set";
  return {
    category: category,
    begin_date: begin_date,
    benefit: benefit
  };
}

const merge_category = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "category",
    "category"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory),
  Curry._1(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory.from_int_exn, 0)
]));

const $$let$6 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_begin_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "begin_date",
    "beginDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$6.name,
    make: $$let$6.make,
    from_proto: $$let$6.from_proto,
    from_proto_exn: $$let$6.from_proto_exn,
    to_proto: $$let$6.to_proto,
    to_proto$p: $$let$6.to_proto$p,
    merge: $$let$6.merge,
    to_json: $$let$6.to_json,
    from_json_exn: $$let$6.from_json_exn,
    from_json: $$let$6.from_json
  })
]));

const merge_oneof_benefit__Pensioner_age = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: PensionerAge.name,
    make: PensionerAge.make,
    from_proto: PensionerAge.from_proto,
    from_proto_exn: PensionerAge.from_proto_exn,
    to_proto: PensionerAge.to_proto,
    to_proto$p: PensionerAge.to_proto$p,
    merge: PensionerAge.merge,
    to_json: PensionerAge.to_json,
    from_json_exn: PensionerAge.from_json_exn,
    from_json: PensionerAge.from_json
  })
]));

const merge_oneof_benefit__Pensioner_duty = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: PensionerDuty.name,
    make: PensionerDuty.make,
    from_proto: PensionerDuty.from_proto,
    from_proto_exn: PensionerDuty.from_proto_exn,
    to_proto: PensionerDuty.to_proto,
    to_proto$p: PensionerDuty.to_proto$p,
    merge: PensionerDuty.merge,
    to_json: PensionerDuty.to_json,
    from_json_exn: PensionerDuty.from_json_exn,
    from_json: PensionerDuty.from_json
  })
]));

const merge_oneof_benefit__Disabled = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Disabled.name,
    make: Disabled.make,
    from_proto: Disabled.from_proto,
    from_proto_exn: Disabled.from_proto_exn,
    to_proto: Disabled.to_proto,
    to_proto$p: Disabled.to_proto$p,
    merge: Disabled.merge,
    to_json: Disabled.to_json,
    from_json_exn: Disabled.from_json_exn,
    from_json: Disabled.from_json
  })
]));

const merge_oneof_benefit__Disabled_permanent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: DisabledPermanent.name,
    make: DisabledPermanent.make,
    from_proto: DisabledPermanent.from_proto,
    from_proto_exn: DisabledPermanent.from_proto_exn,
    to_proto: DisabledPermanent.to_proto,
    to_proto$p: DisabledPermanent.to_proto$p,
    merge: DisabledPermanent.merge,
    to_json: DisabledPermanent.to_json,
    from_json_exn: DisabledPermanent.from_json_exn,
    from_json: DisabledPermanent.from_json
  })
]));

const merge_oneof_benefit__Veteran = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Veteran.name,
    make: Veteran.make,
    from_proto: Veteran.from_proto,
    from_proto_exn: Veteran.from_proto_exn,
    to_proto: Veteran.to_proto,
    to_proto$p: Veteran.to_proto$p,
    merge: Veteran.merge,
    to_json: Veteran.to_json,
    from_json_exn: Veteran.from_json_exn,
    from_json: Veteran.from_json
  })
]));

const merge_oneof_benefit__Guardian_disabled = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: GuardianDisabled.name,
    make: GuardianDisabled.make,
    from_proto: GuardianDisabled.from_proto,
    from_proto_exn: GuardianDisabled.from_proto_exn,
    to_proto: GuardianDisabled.to_proto,
    to_proto$p: GuardianDisabled.to_proto$p,
    merge: GuardianDisabled.merge,
    to_json: GuardianDisabled.to_json,
    from_json_exn: GuardianDisabled.from_json_exn,
    from_json: GuardianDisabled.from_json
  })
]));

const merge_oneof_benefit__Guardian_orphaned = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: GuardianOrphaned.name,
    make: GuardianOrphaned.make,
    from_proto: GuardianOrphaned.from_proto,
    from_proto_exn: GuardianOrphaned.from_proto_exn,
    to_proto: GuardianOrphaned.to_proto,
    to_proto$p: GuardianOrphaned.to_proto$p,
    merge: GuardianOrphaned.merge,
    to_json: GuardianOrphaned.to_json,
    from_json_exn: GuardianOrphaned.from_json_exn,
    from_json: GuardianOrphaned.from_json
  })
]));

const merge_oneof_benefit__Adopter = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Adopter.name,
    make: Adopter.make,
    from_proto: Adopter.from_proto,
    from_proto_exn: Adopter.from_proto_exn,
    to_proto: Adopter.to_proto,
    to_proto$p: Adopter.to_proto$p,
    merge: Adopter.merge,
    to_json: Adopter.to_json,
    from_json_exn: Adopter.from_json_exn,
    from_json: Adopter.from_json
  })
]));

const merge_oneof_benefit__Children = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Children.name,
    make: Children.make,
    from_proto: Children.from_proto,
    from_proto_exn: Children.from_proto_exn,
    to_proto: Children.to_proto,
    to_proto$p: Children.to_proto$p,
    merge: Children.merge,
    to_json: Children.to_json,
    from_json_exn: Children.from_json_exn,
    from_json: Children.from_json
  })
]));

const merge_oneof_benefit__Maternity = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Maternity.name,
    make: Maternity.make,
    from_proto: Maternity.from_proto,
    from_proto_exn: Maternity.from_proto_exn,
    to_proto: Maternity.to_proto,
    to_proto$p: Maternity.to_proto$p,
    merge: Maternity.merge,
    to_json: Maternity.to_json,
    from_json_exn: Maternity.from_json_exn,
    from_json: Maternity.from_json
  })
]));

const merge_oneof_benefit__Convict = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Convict.name,
    make: Convict.make,
    from_proto: Convict.from_proto,
    from_proto_exn: Convict.from_proto_exn,
    to_proto: Convict.to_proto,
    to_proto$p: Convict.to_proto$p,
    merge: Convict.merge,
    to_json: Convict.to_json,
    from_json_exn: Convict.from_json_exn,
    from_json: Convict.from_json
  })
]));

const merge_oneof_benefit__Mother_many = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: MotherMany.name,
    make: MotherMany.make,
    from_proto: MotherMany.from_proto,
    from_proto_exn: MotherMany.from_proto_exn,
    to_proto: MotherMany.to_proto,
    to_proto$p: MotherMany.to_proto$p,
    merge: MotherMany.merge,
    to_json: MotherMany.to_json,
    from_json_exn: MotherMany.from_json_exn,
    from_json: MotherMany.from_json
  })
]));

const merge_oneof_benefit__Student = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Student.name,
    make: Student.make,
    from_proto: Student.from_proto,
    from_proto_exn: Student.from_proto_exn,
    to_proto: Student.to_proto,
    to_proto$p: Student.to_proto$p,
    merge: Student.merge,
    to_json: Student.to_json,
    from_json_exn: Student.from_json_exn,
    from_json: Student.from_json
  })
]));

function merge$13(t1, t2) {
  const match = t1.benefit;
  const match$1 = t2.benefit;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Maternity") {
      if (typeof match$1 === "string" || match$1.NAME !== "Maternity") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Maternity",
          VAL: Curry._2(merge_oneof_benefit__Maternity, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Children") {
      if (typeof match$1 === "string" || match$1.NAME !== "Children") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Children",
          VAL: Curry._2(merge_oneof_benefit__Children, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Disabled") {
      if (typeof match$1 === "string" || match$1.NAME !== "Disabled") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Disabled",
          VAL: Curry._2(merge_oneof_benefit__Disabled, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Pensioner_duty") {
      if (typeof match$1 === "string" || match$1.NAME !== "Pensioner_duty") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Pensioner_duty",
          VAL: Curry._2(merge_oneof_benefit__Pensioner_duty, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Veteran") {
      if (typeof match$1 === "string" || match$1.NAME !== "Veteran") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Veteran",
          VAL: Curry._2(merge_oneof_benefit__Veteran, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Convict") {
      if (typeof match$1 === "string" || match$1.NAME !== "Convict") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Convict",
          VAL: Curry._2(merge_oneof_benefit__Convict, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Mother_many") {
      if (typeof match$1 === "string" || match$1.NAME !== "Mother_many") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Mother_many",
          VAL: Curry._2(merge_oneof_benefit__Mother_many, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Guardian_disabled") {
      if (typeof match$1 === "string" || match$1.NAME !== "Guardian_disabled") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Guardian_disabled",
          VAL: Curry._2(merge_oneof_benefit__Guardian_disabled, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Pensioner_age") {
      if (typeof match$1 === "string" || match$1.NAME !== "Pensioner_age") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Pensioner_age",
          VAL: Curry._2(merge_oneof_benefit__Pensioner_age, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Student") {
      if (typeof match$1 === "string" || match$1.NAME !== "Student") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Student",
          VAL: Curry._2(merge_oneof_benefit__Student, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Guardian_orphaned") {
      if (typeof match$1 === "string" || match$1.NAME !== "Guardian_orphaned") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Guardian_orphaned",
          VAL: Curry._2(merge_oneof_benefit__Guardian_orphaned, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Disabled_permanent") {
      if (typeof match$1 === "string" || match$1.NAME !== "Disabled_permanent") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Disabled_permanent",
          VAL: Curry._2(merge_oneof_benefit__Disabled_permanent, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Adopter" && !(typeof match$1 === "string" || match$1.NAME !== "Adopter")) {
      tmp = {
        NAME: "Adopter",
        VAL: Curry._2(merge_oneof_benefit__Adopter, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
    category: Curry._2(merge_category, t1.category, t2.category),
    begin_date: Curry._2(merge_begin_date, t1.begin_date, t2.begin_date),
    benefit: tmp
  };
}

function spec$8(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "category",
      "category"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory),
    Curry._1(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "begin_date",
      "beginDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
    {
      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
        [
          3,
          "pensioner_age",
          "pensionerAge"
        ],
        Ocaml_protoc_plugin__Spec.message({
          name: PensionerAge.name,
          make: PensionerAge.make,
          from_proto: PensionerAge.from_proto,
          from_proto_exn: PensionerAge.from_proto_exn,
          to_proto: PensionerAge.to_proto,
          to_proto$p: PensionerAge.to_proto$p,
          merge: PensionerAge.merge,
          to_json: PensionerAge.to_json,
          from_json_exn: PensionerAge.from_json_exn,
          from_json: PensionerAge.from_json
        }),
        [
          (function (v) {
            return {
              NAME: "Pensioner_age",
              VAL: v
            };
          }),
          (function (param) {
            if (typeof param === "string") {
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            }
            if (param.NAME === "Pensioner_age") {
              return param.VAL;
            }
            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                  MEL_EXN_ID: Stdlib.Invalid_argument,
                  _1: "Cannot destruct given oneof"
                });
          })
        ]
      ]),
      tl: {
        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
          [
            4,
            "pensioner_duty",
            "pensionerDuty"
          ],
          Ocaml_protoc_plugin__Spec.message({
            name: PensionerDuty.name,
            make: PensionerDuty.make,
            from_proto: PensionerDuty.from_proto,
            from_proto_exn: PensionerDuty.from_proto_exn,
            to_proto: PensionerDuty.to_proto,
            to_proto$p: PensionerDuty.to_proto$p,
            merge: PensionerDuty.merge,
            to_json: PensionerDuty.to_json,
            from_json_exn: PensionerDuty.from_json_exn,
            from_json: PensionerDuty.from_json
          }),
          [
            (function (v) {
              return {
                NAME: "Pensioner_duty",
                VAL: v
              };
            }),
            (function (param) {
              if (typeof param === "string") {
                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                      MEL_EXN_ID: Stdlib.Invalid_argument,
                      _1: "Cannot destruct given oneof"
                    });
              }
              if (param.NAME === "Pensioner_duty") {
                return param.VAL;
              }
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            })
          ]
        ]),
        tl: {
          hd: Ocaml_protoc_plugin__Spec.oneof_elem([
            [
              5,
              "disabled",
              "disabled"
            ],
            Ocaml_protoc_plugin__Spec.message({
              name: Disabled.name,
              make: Disabled.make,
              from_proto: Disabled.from_proto,
              from_proto_exn: Disabled.from_proto_exn,
              to_proto: Disabled.to_proto,
              to_proto$p: Disabled.to_proto$p,
              merge: Disabled.merge,
              to_json: Disabled.to_json,
              from_json_exn: Disabled.from_json_exn,
              from_json: Disabled.from_json
            }),
            [
              (function (v) {
                return {
                  NAME: "Disabled",
                  VAL: v
                };
              }),
              (function (param) {
                if (typeof param === "string") {
                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                        MEL_EXN_ID: Stdlib.Invalid_argument,
                        _1: "Cannot destruct given oneof"
                      });
                }
                if (param.NAME === "Disabled") {
                  return param.VAL;
                }
                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                      MEL_EXN_ID: Stdlib.Invalid_argument,
                      _1: "Cannot destruct given oneof"
                    });
              })
            ]
          ]),
          tl: {
            hd: Ocaml_protoc_plugin__Spec.oneof_elem([
              [
                6,
                "disabled_permanent",
                "disabledPermanent"
              ],
              Ocaml_protoc_plugin__Spec.message({
                name: DisabledPermanent.name,
                make: DisabledPermanent.make,
                from_proto: DisabledPermanent.from_proto,
                from_proto_exn: DisabledPermanent.from_proto_exn,
                to_proto: DisabledPermanent.to_proto,
                to_proto$p: DisabledPermanent.to_proto$p,
                merge: DisabledPermanent.merge,
                to_json: DisabledPermanent.to_json,
                from_json_exn: DisabledPermanent.from_json_exn,
                from_json: DisabledPermanent.from_json
              }),
              [
                (function (v) {
                  return {
                    NAME: "Disabled_permanent",
                    VAL: v
                  };
                }),
                (function (param) {
                  if (typeof param === "string") {
                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                          MEL_EXN_ID: Stdlib.Invalid_argument,
                          _1: "Cannot destruct given oneof"
                        });
                  }
                  if (param.NAME === "Disabled_permanent") {
                    return param.VAL;
                  }
                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                        MEL_EXN_ID: Stdlib.Invalid_argument,
                        _1: "Cannot destruct given oneof"
                      });
                })
              ]
            ]),
            tl: {
              hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                [
                  7,
                  "veteran",
                  "veteran"
                ],
                Ocaml_protoc_plugin__Spec.message({
                  name: Veteran.name,
                  make: Veteran.make,
                  from_proto: Veteran.from_proto,
                  from_proto_exn: Veteran.from_proto_exn,
                  to_proto: Veteran.to_proto,
                  to_proto$p: Veteran.to_proto$p,
                  merge: Veteran.merge,
                  to_json: Veteran.to_json,
                  from_json_exn: Veteran.from_json_exn,
                  from_json: Veteran.from_json
                }),
                [
                  (function (v) {
                    return {
                      NAME: "Veteran",
                      VAL: v
                    };
                  }),
                  (function (param) {
                    if (typeof param === "string") {
                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                            MEL_EXN_ID: Stdlib.Invalid_argument,
                            _1: "Cannot destruct given oneof"
                          });
                    }
                    if (param.NAME === "Veteran") {
                      return param.VAL;
                    }
                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                          MEL_EXN_ID: Stdlib.Invalid_argument,
                          _1: "Cannot destruct given oneof"
                        });
                  })
                ]
              ]),
              tl: {
                hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                  [
                    8,
                    "guardian_disabled",
                    "guardianDisabled"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                    name: GuardianDisabled.name,
                    make: GuardianDisabled.make,
                    from_proto: GuardianDisabled.from_proto,
                    from_proto_exn: GuardianDisabled.from_proto_exn,
                    to_proto: GuardianDisabled.to_proto,
                    to_proto$p: GuardianDisabled.to_proto$p,
                    merge: GuardianDisabled.merge,
                    to_json: GuardianDisabled.to_json,
                    from_json_exn: GuardianDisabled.from_json_exn,
                    from_json: GuardianDisabled.from_json
                  }),
                  [
                    (function (v) {
                      return {
                        NAME: "Guardian_disabled",
                        VAL: v
                      };
                    }),
                    (function (param) {
                      if (typeof param === "string") {
                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                              MEL_EXN_ID: Stdlib.Invalid_argument,
                              _1: "Cannot destruct given oneof"
                            });
                      }
                      if (param.NAME === "Guardian_disabled") {
                        return param.VAL;
                      }
                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                            MEL_EXN_ID: Stdlib.Invalid_argument,
                            _1: "Cannot destruct given oneof"
                          });
                    })
                  ]
                ]),
                tl: {
                  hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                    [
                      9,
                      "guardian_orphaned",
                      "guardianOrphaned"
                    ],
                    Ocaml_protoc_plugin__Spec.message({
                      name: GuardianOrphaned.name,
                      make: GuardianOrphaned.make,
                      from_proto: GuardianOrphaned.from_proto,
                      from_proto_exn: GuardianOrphaned.from_proto_exn,
                      to_proto: GuardianOrphaned.to_proto,
                      to_proto$p: GuardianOrphaned.to_proto$p,
                      merge: GuardianOrphaned.merge,
                      to_json: GuardianOrphaned.to_json,
                      from_json_exn: GuardianOrphaned.from_json_exn,
                      from_json: GuardianOrphaned.from_json
                    }),
                    [
                      (function (v) {
                        return {
                          NAME: "Guardian_orphaned",
                          VAL: v
                        };
                      }),
                      (function (param) {
                        if (typeof param === "string") {
                          throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                MEL_EXN_ID: Stdlib.Invalid_argument,
                                _1: "Cannot destruct given oneof"
                              });
                        }
                        if (param.NAME === "Guardian_orphaned") {
                          return param.VAL;
                        }
                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                              MEL_EXN_ID: Stdlib.Invalid_argument,
                              _1: "Cannot destruct given oneof"
                            });
                      })
                    ]
                  ]),
                  tl: {
                    hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                      [
                        10,
                        "adopter",
                        "adopter"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                        name: Adopter.name,
                        make: Adopter.make,
                        from_proto: Adopter.from_proto,
                        from_proto_exn: Adopter.from_proto_exn,
                        to_proto: Adopter.to_proto,
                        to_proto$p: Adopter.to_proto$p,
                        merge: Adopter.merge,
                        to_json: Adopter.to_json,
                        from_json_exn: Adopter.from_json_exn,
                        from_json: Adopter.from_json
                      }),
                      [
                        (function (v) {
                          return {
                            NAME: "Adopter",
                            VAL: v
                          };
                        }),
                        (function (param) {
                          if (typeof param === "string") {
                            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                  _1: "Cannot destruct given oneof"
                                });
                          }
                          if (param.NAME === "Adopter") {
                            return param.VAL;
                          }
                          throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                MEL_EXN_ID: Stdlib.Invalid_argument,
                                _1: "Cannot destruct given oneof"
                              });
                        })
                      ]
                    ]),
                    tl: {
                      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                        [
                          11,
                          "children",
                          "children"
                        ],
                        Ocaml_protoc_plugin__Spec.message({
                          name: Children.name,
                          make: Children.make,
                          from_proto: Children.from_proto,
                          from_proto_exn: Children.from_proto_exn,
                          to_proto: Children.to_proto,
                          to_proto$p: Children.to_proto$p,
                          merge: Children.merge,
                          to_json: Children.to_json,
                          from_json_exn: Children.from_json_exn,
                          from_json: Children.from_json
                        }),
                        [
                          (function (v) {
                            return {
                              NAME: "Children",
                              VAL: v
                            };
                          }),
                          (function (param) {
                            if (typeof param === "string") {
                              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                    MEL_EXN_ID: Stdlib.Invalid_argument,
                                    _1: "Cannot destruct given oneof"
                                  });
                            }
                            if (param.NAME === "Children") {
                              return param.VAL;
                            }
                            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                  _1: "Cannot destruct given oneof"
                                });
                          })
                        ]
                      ]),
                      tl: {
                        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                          [
                            12,
                            "maternity",
                            "maternity"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                            name: Maternity.name,
                            make: Maternity.make,
                            from_proto: Maternity.from_proto,
                            from_proto_exn: Maternity.from_proto_exn,
                            to_proto: Maternity.to_proto,
                            to_proto$p: Maternity.to_proto$p,
                            merge: Maternity.merge,
                            to_json: Maternity.to_json,
                            from_json_exn: Maternity.from_json_exn,
                            from_json: Maternity.from_json
                          }),
                          [
                            (function (v) {
                              return {
                                NAME: "Maternity",
                                VAL: v
                              };
                            }),
                            (function (param) {
                              if (typeof param === "string") {
                                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                      MEL_EXN_ID: Stdlib.Invalid_argument,
                                      _1: "Cannot destruct given oneof"
                                    });
                              }
                              if (param.NAME === "Maternity") {
                                return param.VAL;
                              }
                              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                    MEL_EXN_ID: Stdlib.Invalid_argument,
                                    _1: "Cannot destruct given oneof"
                                  });
                            })
                          ]
                        ]),
                        tl: {
                          hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                            [
                              13,
                              "convict",
                              "convict"
                            ],
                            Ocaml_protoc_plugin__Spec.message({
                              name: Convict.name,
                              make: Convict.make,
                              from_proto: Convict.from_proto,
                              from_proto_exn: Convict.from_proto_exn,
                              to_proto: Convict.to_proto,
                              to_proto$p: Convict.to_proto$p,
                              merge: Convict.merge,
                              to_json: Convict.to_json,
                              from_json_exn: Convict.from_json_exn,
                              from_json: Convict.from_json
                            }),
                            [
                              (function (v) {
                                return {
                                  NAME: "Convict",
                                  VAL: v
                                };
                              }),
                              (function (param) {
                                if (typeof param === "string") {
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                        MEL_EXN_ID: Stdlib.Invalid_argument,
                                        _1: "Cannot destruct given oneof"
                                      });
                                }
                                if (param.NAME === "Convict") {
                                  return param.VAL;
                                }
                                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                      MEL_EXN_ID: Stdlib.Invalid_argument,
                                      _1: "Cannot destruct given oneof"
                                    });
                              })
                            ]
                          ]),
                          tl: {
                            hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                              [
                                14,
                                "mother_many",
                                "motherMany"
                              ],
                              Ocaml_protoc_plugin__Spec.message({
                                name: MotherMany.name,
                                make: MotherMany.make,
                                from_proto: MotherMany.from_proto,
                                from_proto_exn: MotherMany.from_proto_exn,
                                to_proto: MotherMany.to_proto,
                                to_proto$p: MotherMany.to_proto$p,
                                merge: MotherMany.merge,
                                to_json: MotherMany.to_json,
                                from_json_exn: MotherMany.from_json_exn,
                                from_json: MotherMany.from_json
                              }),
                              [
                                (function (v) {
                                  return {
                                    NAME: "Mother_many",
                                    VAL: v
                                  };
                                }),
                                (function (param) {
                                  if (typeof param === "string") {
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                          MEL_EXN_ID: Stdlib.Invalid_argument,
                                          _1: "Cannot destruct given oneof"
                                        });
                                  }
                                  if (param.NAME === "Mother_many") {
                                    return param.VAL;
                                  }
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                        MEL_EXN_ID: Stdlib.Invalid_argument,
                                        _1: "Cannot destruct given oneof"
                                      });
                                })
                              ]
                            ]),
                            tl: {
                              hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                [
                                  15,
                                  "student",
                                  "student"
                                ],
                                Ocaml_protoc_plugin__Spec.message({
                                  name: Student.name,
                                  make: Student.make,
                                  from_proto: Student.from_proto,
                                  from_proto_exn: Student.from_proto_exn,
                                  to_proto: Student.to_proto,
                                  to_proto$p: Student.to_proto$p,
                                  merge: Student.merge,
                                  to_json: Student.to_json,
                                  from_json_exn: Student.from_json_exn,
                                  from_json: Student.from_json
                                }),
                                [
                                  (function (v) {
                                    return {
                                      NAME: "Student",
                                      VAL: v
                                    };
                                  }),
                                  (function (param) {
                                    if (typeof param === "string") {
                                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                    }
                                    if (param.NAME === "Student") {
                                      return param.VAL;
                                    }
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                          MEL_EXN_ID: Stdlib.Invalid_argument,
                                          _1: "Cannot destruct given oneof"
                                        });
                                  })
                                ]
                              ]),
                              tl: /* [] */ 0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    (function (param) {
      if (typeof param === "string") {
        return Stdlib.failwith("Impossible case");
      }
      const variant = param.NAME;
      if (variant === "Children") {
        return 8;
      } else if (variant === "Disabled") {
        return 2;
      } else if (variant === "Pensioner_duty") {
        return 1;
      } else if (variant === "Veteran") {
        return 4;
      } else if (variant === "Convict") {
        return 10;
      } else if (variant === "Mother_many") {
        return 11;
      } else if (variant === "Guardian_disabled") {
        return 5;
      } else if (variant === "Pensioner_age") {
        return 0;
      } else if (variant === "Student") {
        return 12;
      } else if (variant === "Guardian_orphaned") {
        return 6;
      } else if (variant === "Disabled_permanent") {
        return 3;
      } else if (variant === "Adopter") {
        return 7;
      } else {
        return 9;
      }
    })
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$13(writer, param) {
  Curry._4(serialize$13, writer, param.category, param.begin_date, param.benefit);
}

function to_proto$13(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$13(writer, t);
  return writer;
}

function constructor$16(category, begin_date, benefit) {
  return {
    category: category,
    begin_date: begin_date,
    benefit: benefit
  };
}

const from_proto_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$13(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$13, writer);
  });
}

function to_json$13(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit", spec$8(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.category, param.begin_date, param.benefit);
  };
}

function constructor$17(category, begin_date, benefit) {
  return {
    category: category,
    begin_date: begin_date,
    benefit: benefit
  };
}

const from_json_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1alpha1.PersonCategoryBenefit", spec$8(undefined), constructor$17);
});

function from_json$13(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$13, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PensionerAge"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PensionerDuty"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Disabled"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DisabledPermanent"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Veteran"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "GuardianDisabled"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "GuardianOrphaned"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Adopter"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Children"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Maternity"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Convict"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "MotherMany"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Student"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, PersonCategoryBenefit, {
  PensionerAge: PensionerAge,
  PensionerDuty: PensionerDuty,
  Disabled: Disabled,
  DisabledPermanent: DisabledPermanent,
  Veteran: Veteran,
  GuardianDisabled: GuardianDisabled,
  GuardianOrphaned: GuardianOrphaned,
  Adopter: Adopter,
  Children: Children,
  Maternity: Maternity,
  Convict: Convict,
  MotherMany: MotherMany,
  Student: Student,
  make: make$13,
  to_proto: to_proto$13,
  from_proto: from_proto$13,
  to_json: to_json$13,
  from_json: from_json$13,
  name: name$13,
  merge: merge$13,
  to_proto$p: to_proto$p$13,
  from_proto_exn: from_proto_exn$13,
  from_json_exn: from_json_exn$13
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PensionerAge"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PensionerDuty"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Disabled"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "DisabledPermanent"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Veteran"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "GuardianDisabled"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "GuardianOrphaned"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Adopter"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Children"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Maternity"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Convict"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "MotherMany"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Student"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PersonCategoryBenefit"
    ]]
}, V1alpha1, {
  PersonCategoryBenefit: PersonCategoryBenefit
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "PensionerAge"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "PensionerDuty"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Disabled"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "DisabledPermanent"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Veteran"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "GuardianDisabled"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "GuardianOrphaned"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Adopter"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Children"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Maternity"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Convict"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "MotherMany"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Student"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "PersonCategoryBenefit"
          ]]
      },
      "V1alpha1"
    ]]
}, Control, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "PensionerAge"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "PensionerDuty"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Disabled"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "DisabledPermanent"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Veteran"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "GuardianDisabled"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "GuardianOrphaned"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Adopter"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Children"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Maternity"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Convict"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "MotherMany"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "Student"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "PersonCategoryBenefit"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Control"
    ]]
}, Tax, {
  Control: Control
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "PensionerAge"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "PensionerDuty"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Disabled"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "DisabledPermanent"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Veteran"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "GuardianDisabled"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "GuardianOrphaned"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Adopter"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Children"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Maternity"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Convict"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "MotherMany"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "Student"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "PersonCategoryBenefit"
                      ]]
                  },
                  "V1alpha1"
                ]]
            },
            "Control"
          ]]
      },
      "Tax"
    ]]
}, Buhta, {
  Tax: Tax
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
